/*
 * @Author: Chao Yang
 * @Date: 2019-09-24 02:40:14
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-05-20 17:41:10
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'app/dashboard',
  },
  {
    loadChildren: () => import('./page/landing/landing.module').then(m => m.LandingModule),
    path: 'app',
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'app/dashboard',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
